import React, { useState, useEffect } from "react";
import { Box, Button, Typography, TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import ModalComponent from "./Modal";
import useFetchInstruments from "../../hooks/useFetchInstruments";

const EditInstrumentAssociationModal = ({ showModal, handleCloseModal, value, onSubmitAssociate }) => {
  const { data: fetchedInstruments, error, loading, refetch: refetchInstruments } = useFetchInstruments();
  const [filteredInstruments, setFilteredInstruments] = useState([]);
  const [selectedInstrument, setSelectedInstrument] = useState(null);
  const [instrumentInput, setInstrumentInput] = useState("");

  useEffect(() => {
    if (showModal) {
      refetchInstruments();
    }
  }, [showModal, refetchInstruments]);

  useEffect(() => {
    if (showModal) {
      setSelectedInstrument(null);
      setInstrumentInput("");
    }
  }, [showModal]);

  useEffect(() => {
    if (instrumentInput) {
      const filtered = (fetchedInstruments || []).filter((instrument) => instrument.name.toLowerCase().includes(instrumentInput.toLowerCase()));
      setFilteredInstruments(filtered);
    } else {
      setFilteredInstruments(fetchedInstruments || []);
    }
  }, [instrumentInput, fetchedInstruments]);

  return (
    <ModalComponent open={showModal} onClose={handleCloseModal} width="600px">
      <Box sx={{ p: 4 }}>
        {/* Encabezado */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
          <Typography variant="h6" fontWeight={600} sx={{ lineHeight: 1.2 }}>
            Asociación de Instrumento al Cuestionario
          </Typography>
        </Box>

        {/* Descripción */}
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          Escoja el instrumento que desea asociar al cuestionario seleccionado.
        </Typography>

        {/* Campo de entrada */}
        <Autocomplete
          value={selectedInstrument}
          onChange={(e, newValue) => setSelectedInstrument(newValue)}
          inputValue={instrumentInput}
          onInputChange={(e, newInputValue) => setInstrumentInput(newInputValue)}
          options={filteredInstruments || []}
          getOptionLabel={(option) => (typeof option === "string" ? option : option?.name || "")}
          isOptionEqualToValue={(option, v) => Number(option.id) === Number(v?.id)}
          loading={loading}
          disabled={loading || !!error}
          fullWidth
          renderInput={(params) => <TextField {...params} size="small" label="Instrumento" placeholder="Escriba para buscar…" />}
          renderOption={(props, option) => (
            <li {...props} key={option.id}>
              {option.name}
            </li>
          )}
          openOnFocus
          clearOnBlur={false}
          blurOnSelect
        />

        {/* Botones de acción */}
        <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
          <Button
            variant="contained"
            onClick={() => {
              onSubmitAssociate(selectedInstrument);
            }}
            sx={{ minHeight: 40, flex: 1 }}
            disabled={!selectedInstrument || loading || !!error}
          >
            Aceptar
          </Button>
          <Button variant="outlined" onClick={handleCloseModal} sx={{ minHeight: 40, flex: 1 }}>
            Cancelar
          </Button>
        </Box>
      </Box>
    </ModalComponent>
  );
};

export default EditInstrumentAssociationModal;
